module.exports = __webpack_public_path__ + "static/media/uni.6a4d26d5.png";